var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    _vm._l(_vm.certificados, function (cert) {
      return _c("certificado-card", {
        key: cert.id,
        attrs: { certificado: cert },
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }